module.exports = __webpack_public_path__ + "static/media/foodshot13.e1c4d6cd.JPG";